import "./header.css";
import logo from "global_assets/logo.png";
import React from "react";
import { NavHashLink } from "react-router-hash-link";
import { NavLink } from "react-router-dom";
import underline from "./assets/underline.png";

function Header() {
  return (
    <header className="header">
      <a href="/">
        <img src={logo} alt="Cherry Crisis" className="logo" />
      </a>
      <nav className="navigation">
        <ul className="navigationList">
          <li>
            <NavHashLink className="mx-auto" to="/#shows">
              {({ isActive }) => (
                <div>
                  <img
                    alt=""
                    className={isActive ? "underline" : "hover-style"}
                    src={underline}
                  ></img>
                  Shows
                </div>
              )}
            </NavHashLink>
          </li>
          <li>
            <NavLink className="mx-auto" to="/about">
              {({ isActive }) => (
                <div>
                  <img
                    alt=""
                    className={isActive ? "underline" : "hover-style"}
                    src={underline}
                  ></img>
                  About Us
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink className="mx-auto" to="/contact">
              {({ isActive }) => (
                <div>
                  <img
                    alt=""
                    className={isActive ? "underline" : "hover-style"}
                    src={underline}
                  ></img>
                  Contact
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink className="mx-auto test" to="/gallery">
              {({ isActive }) => (
                <div>
                  <img
                    alt=""
                    className={isActive ? "underline" : "hover-style"}
                    src={underline}
                  ></img>
                  Gallery
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink className="mx-auto" to="/blog">
              {({ isActive }) => (
                <div>
                  <img
                    alt=""
                    className={isActive ? "underline" : "hover-style"}
                    src={underline}
                  ></img>
                  Blog
                </div>
              )}
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
